export const variants = [
  {
    props: { variant: "rounded" },
    style: {
      borderRadius: "30px",
    },
  },
  {
    props: { variant: "lessRounded" },
    style: {
      borderRadius: "10px !important",
    },
  },
  {
    props: { variant: "squared" },
    style: {
      borderRadius: "4px !important",
    },
  },
  {
    props: { variant: "text" },
    style: ({ theme: t }) => ({
      color: "#222222",
      marginEight: "16px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: t.palette.common.sh_lightgrey,
      },
    }),
  },
  {
    props: { variant: "textUnderline" },
    style: () => ({
      color: "#222222",
      marginEight: "16px",
      textTransform: "none",
      textDecoration: "underline !important",
      "&:hover": {
        backgroundColor: "inherit",
        opacity: 0.86,
        textDecoration: "underline !important",
      },
    }),
  },
  {
    props: { variant: "textUnderlineOnHover" },
    style: () => ({
      color: "#222222",
      fontSize: "16px",
      height: "fit-content",
      padding: 0,
      marginEight: "16px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "inherit",
        textDecoration: "underline !important",
      },
    }),
  },

  /*
    COLORS
   */
  {
    props: { color: "primaryContained" },
    style: ({ theme: t }) => ({
      backgroundColor: t.palette.primary.main,
      color: t.palette.common.white,
      fontWeight: "600",
      "&:hover": {
        backgroundColor: t.palette.primary.dark,
      },
      "&.Mui-disabled": {
        color: t.palette.common.white,
        opacity: "0.8",
        cursor: "not-allowed",
        pointerEvents: "unset",
      },
      "& > .MuiLoadingButton-loadingIndicator": {
        color: t.palette.common.white,
      },
    }),
  },
  {
    props: { color: "primaryOutlined" },
    style: ({ theme: t }) => ({
      border: `1px solid ${t.palette.primary.main}`,
      backgroundColor: "transparent",
      color: t.palette.primary.main,
      fontWeight: "600",
      "&:hover": {
        backgroundColor: t.palette.primary.main,
        color: t.palette.common.white,
      },
      "&.Mui-disabled": {
        color: t.palette.primary.main,
        opacity: "0.8",
        cursor: "not-allowed",
        pointerEvents: "unset",
      },
      "& > .MuiLoadingButton-loadingIndicator": {
        color: t.palette.primary.main,
      },
    }),
  },
  {
    props: { color: "secondaryContained" },
    style: ({ theme: t }) => ({
      borderRadius: "30px",
      backgroundColor: t.palette.secondary.main,
      color: t.palette.common.white,
      fontWeight: "600",
      "&:hover": {
        backgroundColor: t.palette.secondary.dark,
      },
      "&.Mui-disabled": {
        color: t.palette.common.white,
        opacity: "0.8",
        cursor: "not-allowed",
        pointerEvents: "unset",
      },
      "& > .MuiLoadingButton-loadingIndicator": {
        color: t.palette.common.white,
      },
    }),
  },
  {
    props: { color: "secondaryOutlined" },
    style: ({ theme: t }) => ({
      border: `1px solid ${t.palette.secondary.main}`,
      backgroundColor: "transparent",
      color: t.palette.secondary.main,
      fontWeight: "600",
      "&:hover": {
        backgroundColor: t.palette.secondary.dark,
        color: t.palette.common.white,
      },
      "&.Mui-disabled": {
        color: t.palette.secondary.main,
        opacity: "0.8",
        cursor: "not-allowed",
        pointerEvents: "unset",
      },
      "& > .MuiLoadingButton-loadingIndicator": {
        color: t.palette.secondary.main,
      },
    }),
  },
  {
    props: { color: "whiteContained" },
    style: ({ theme: t }) => ({
      border: `1px solid ${t.palette.secondary.smoke}`,
      backgroundColor: t.palette.common.white,
      color: t.palette.secondary.main,
      fontWeight: "600",
      "&:hover": {
        backgroundColor: t.palette.secondary.lighter,
        color: t.palette.common.white,
      },
      "&.Mui-disabled": {
        color: t.palette.secondary.main,
        opacity: "0.8",
        cursor: "not-allowed",
        pointerEvents: "unset",
      },
      "& > .MuiLoadingButton-loadingIndicator": {
        color: t.palette.secondary.main,
      },
    }),
  },
  {
    props: { color: "dangerContained" },
    style: ({ theme: t }) => ({
      borderRadius: "30px",
      backgroundColor: t.palette.error.main,
      color: t.palette.common.white,
      fontWeight: "600",
      "&:hover": {
        backgroundColor: t.palette.error.dark,
      },
      "&.Mui-disabled": {
        color: t.palette.common.white,
        opacity: "0.8",
        cursor: "not-allowed",
        pointerEvents: "unset",
      },
    }),
  },
  {
    props: { color: "dangerOutlined" },
    style: ({ theme: t }) => ({
      border: `1px solid ${t.palette.error.main}`,
      borderRadius: "30px",
      backgroundColor: t.palette.common.white,
      color: t.palette.error.main,
      fontWeight: "600",

      "&:hover": {
        backgroundColor: t.palette.error.smoke,
      },
      "&.Mui-disabled": {
        color: t.palette.error.light,
        cursor: "not-allowed",
        pointerEvents: "unset",
      },
      "& > .MuiLoadingButton-loadingIndicator": {
        color: t.palette.error.main,
      },
    }),
  },

  /*
    SIZES
   */
  {
    props: { size: "xsmall" },
    style: {
      height: "24px",
    },
  },
  {
    props: { size: "small" },
    style: {
      height: "36px",
    },
  },
  {
    props: { size: "medium" },
    style: {
      height: "48px",
    },
  },
  {
    props: { size: "large" },
    style: {
      height: "56px",
    },
  },
];
